module.exports = __webpack_public_path__ + "static/img/RWG.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/szafa/RWG.png
// module id = Hmbe
// module chunks = 0